module.exports = __webpack_public_path__ + "static/sprache-70c14e8c5d10221f969d9e634ba2a9b9.jpg";